/* template */
<template minapp="mpx" xlang="wxml"><div class="es-add-button__add"><es-button block :disabled="(disabled)" @click="handleClick" :custom-class='["es-add-button__add-btn"].join(" ")'><div class="es-add-button__add-btn-text"><mpx-image src="https://ut-static.udache.com/webx/sfc/fA9jGStTWK7w5yd2a6Q_s_clipboard_image_1699414509016.png" class="es-add-button__add-btn-icon"></mpx-image><span>{{text}}</span></div></es-button></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m6e00a244"}'>
  +b('add-button')
    +e('add')
      /deep/ .es-button--disabled
        color #ffffff !important 
        background-color #cccccc !important
        opacity 1 !important

    +e('add-btn')
      color #FF6400 !important
      border-radius 8px !important
      border none !important
      height 48px !important

    +e('add-btn-text')
      display flex
      font-weight 500
      align-items center
      font-size 14px

    +e('add-btn-icon')
      width 15px
      height 15px
      margin-right 4px
  
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m6e00a244"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isComponent&outputPath=components%2Findex6e00a244%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Findex6e00a244%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m6e00a244"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/index6e00a244/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'es-button':getComponent(require("../../../../../node_modules/@didi/es-mpx-ui/lib/button/index.mpx?isComponent&outputPath=components%2Findexbc68cb48%2Findex")),'es-icon':getComponent(require("../../../../../node_modules/@didi/es-mpx-ui/lib/icon/index.mpx?isComponent&outputPath=components%2Findex6fe48a3a%2Findex")),'mpx-image':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
